<template>
  <div class="top">
    <van-nav-bar :title="title" fixed class="header-navbar">
      <!-- menu btn start -->
      <!-- <van-button slot="left" size="small">
        <van-icon name="wap-nav" />
      </van-button> -->
      <!-- menu btn end -->
      <!-- right tool menu start -->
      <van-button v-if="unlogin" slot="right" size="small" @click="toLogin()">
        登录
      </van-button>
      <!-- <van-button v-else slot="right" size="small" @click="toLogout()">退出</van-button> -->

      <!-- right tool menu start -->
    </van-nav-bar>
  </div>
</template>
<script>
import { logout } from '@/api/theApi'
export default {
	props: {
		title: {
			type: String,
			default: 'Ainvest'
		},
		unlogin: {
			type: Boolean,
			default: true
		}
	},
	mounted() {
		// 确保导航栏固定定位正确
		this.$nextTick(() => {
			this.ensureNavbarFixed();
		});
	},
	methods: {
		toLogin() {
			this.$router.push({
				path: '/login'
			})
		},
		async toLogout() {
			// 必须等 logout() 完成再跳转：cookie 模式下服务端在这次响应里既撤销会话族、
			// 又通过 Set-Cookie 清掉 HttpOnly 的 refresh_token/family_id。若不 await 就
			// window.location 跳转，请求会被导航中断——会话族不撤销、cookie 也没清掉，
			// 下次进入时 initAuth() 会拿残留的 refresh cookie 把用户静默登回去。
			// try/catch：网络失败也要让用户在客户端登出（继续跳转），不困在原页。
			try {
				await logout()
			} catch (e) {}
			localStorage.clear()
			window.location.href = process.env.BASE_URL
		},
		ensureNavbarFixed() {
			// 确保导航栏样式正确
			const navbar = this.$el.querySelector('.van-nav-bar');
			if (navbar) {
				navbar.style.position = 'fixed';
				navbar.style.top = '0';
				navbar.style.left = '0';
				navbar.style.right = '0';
				navbar.style.zIndex = '1000';
			}
		}
	}
}
</script>

<style lang="less" scoped>
.top {
  position: relative;
  z-index: 1000;
}

// 确保导航栏固定定位样式
.header-navbar {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
  width: 100% !important;
}

// 全局覆盖确保优先级
::v-deep .van-nav-bar {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  z-index: 1000 !important;
  width: 100% !important;
}
</style>
